import _defineProperty from "/var/lib/jenkins/workspace/HFM_MS_R5.04_May10-CustomerEngage_AM_warfilebuild-PROD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/var/lib/jenkins/workspace/HFM_MS_R5.04_May10-CustomerEngage_AM_warfilebuild-PROD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { COLOR, SHAPE } from '../../channel';
import { getFieldOrDatumDef, isFieldDef } from '../../channeldef';
import { LEGEND_SCALE_CHANNELS } from '../../legend';
import { normalizeTimeUnit } from '../../timeunit';
import { GEOJSON } from '../../type';
import { deleteNestedProperty, isEmpty, keys, varName } from '../../util';
import { mergeTitleComponent } from '../common';
import { guideEncodeEntry } from '../guide';
import { isUnitModel } from '../model';
import { parseGuideResolve } from '../resolve';
import { parseInteractiveLegend } from '../selection/transforms/legends';
import { defaultTieBreaker, makeImplicit, mergeValuesWithExplicit } from '../split';
import { LegendComponent, LEGEND_COMPONENT_PROPERTIES } from './component';
import { legendEncodeRules } from './encode';
import { getDirection, getLegendType, legendRules } from './properties';
export function parseLegend(model) {
  var legendComponent = isUnitModel(model) ? parseUnitLegend(model) : parseNonUnitLegend(model);
  model.component.legends = legendComponent;
  return legendComponent;
}

function parseUnitLegend(model) {
  var encoding = model.encoding;
  var legendComponent = {};

  for (var _i = 0, _arr = [COLOR].concat(_toConsumableArray(LEGEND_SCALE_CHANNELS)); _i < _arr.length; _i++) {
    var channel = _arr[_i];
    var def = getFieldOrDatumDef(encoding[channel]);

    if (!def || !model.getScaleComponent(channel)) {
      continue;
    }

    if (channel === SHAPE && isFieldDef(def) && def.type === GEOJSON) {
      continue;
    }

    legendComponent[channel] = parseLegendForChannel(model, channel);
  }

  return legendComponent;
}

function getLegendDefWithScale(model, channel) {
  var scale = model.scaleName(channel);

  if (model.mark === 'trail') {
    if (channel === 'color') {
      // trail is a filled mark, but its default symbolType ("stroke") should use "stroke"
      return {
        stroke: scale
      };
    } else if (channel === 'size') {
      return {
        strokeWidth: scale
      };
    }
  }

  if (channel === 'color') {
    return model.markDef.filled ? {
      fill: scale
    } : {
      stroke: scale
    };
  }

  return _defineProperty({}, channel, scale);
} // eslint-disable-next-line @typescript-eslint/ban-types


function isExplicit(value, property, legend, fieldDef) {
  switch (property) {
    case 'disable':
      return legend !== undefined;
    // if axis is specified or null/false, then it's enable/disable state is explicit

    case 'values':
      // specified legend.values is already respected, but may get transformed.
      return !!(legend === null || legend === void 0 ? void 0 : legend.values);

    case 'title':
      // title can be explicit if fieldDef.title is set
      if (property === 'title' && value === (fieldDef === null || fieldDef === void 0 ? void 0 : fieldDef.title)) {
        return true;
      }

  } // Otherwise, things are explicit if the returned value matches the specified property


  return value === (legend || {})[property];
}

export function parseLegendForChannel(model, channel) {
  var _a, _b, _c;

  var legend = model.legend(channel);
  var markDef = model.markDef,
      encoding = model.encoding,
      config = model.config;
  var legendConfig = config.legend;
  var legendCmpt = new LegendComponent({}, getLegendDefWithScale(model, channel));
  parseInteractiveLegend(model, channel, legendCmpt);
  var disable = legend !== undefined ? !legend : legendConfig.disable;
  legendCmpt.set('disable', disable, legend !== undefined);

  if (disable) {
    return legendCmpt;
  }

  legend = legend || {};
  var scaleType = model.getScaleComponent(channel).get('type');
  var fieldOrDatumDef = getFieldOrDatumDef(encoding[channel]);
  var timeUnit = isFieldDef(fieldOrDatumDef) ? (_a = normalizeTimeUnit(fieldOrDatumDef.timeUnit)) === null || _a === void 0 ? void 0 : _a.unit : undefined;
  var orient = legend.orient || config.legend.orient || 'right';
  var legendType = getLegendType({
    legend: legend,
    channel: channel,
    timeUnit: timeUnit,
    scaleType: scaleType
  });
  var direction = getDirection({
    legend: legend,
    legendType: legendType,
    orient: orient,
    legendConfig: legendConfig
  });
  var ruleParams = {
    legend: legend,
    channel: channel,
    model: model,
    markDef: markDef,
    encoding: encoding,
    fieldOrDatumDef: fieldOrDatumDef,
    legendConfig: legendConfig,
    config: config,
    scaleType: scaleType,
    orient: orient,
    legendType: legendType,
    direction: direction
  };

  var _iterator = _createForOfIteratorHelper(LEGEND_COMPONENT_PROPERTIES),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var property = _step.value;

      if (legendType === 'gradient' && property.startsWith('symbol') || legendType === 'symbol' && property.startsWith('gradient')) {
        continue;
      }

      var _value = property in legendRules ? legendRules[property](ruleParams) : legend[property];

      if (_value !== undefined) {
        var explicit = isExplicit(_value, property, legend, model.fieldDef(channel));

        if (explicit || config.legend[property] === undefined) {
          legendCmpt.set(property, _value, explicit);
        }
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  var legendEncoding = (_b = legend === null || legend === void 0 ? void 0 : legend.encoding) !== null && _b !== void 0 ? _b : {};
  var selections = legendCmpt.get('selections');
  var legendEncode = {};
  var legendEncodeParams = {
    fieldOrDatumDef: fieldOrDatumDef,
    model: model,
    channel: channel,
    legendCmpt: legendCmpt,
    legendType: legendType
  };

  for (var _i2 = 0, _arr2 = ['labels', 'legend', 'title', 'symbols', 'gradient', 'entries']; _i2 < _arr2.length; _i2++) {
    var part = _arr2[_i2];
    var legendEncodingPart = guideEncodeEntry((_c = legendEncoding[part]) !== null && _c !== void 0 ? _c : {}, model);
    var value = part in legendEncodeRules ? legendEncodeRules[part](legendEncodingPart, legendEncodeParams) // apply rule
    : legendEncodingPart; // no rule -- just default values

    if (value !== undefined && !isEmpty(value)) {
      legendEncode[part] = Object.assign(Object.assign(Object.assign({}, (selections === null || selections === void 0 ? void 0 : selections.length) && isFieldDef(fieldOrDatumDef) ? {
        name: "".concat(varName(fieldOrDatumDef.field), "_legend_").concat(part)
      } : {}), (selections === null || selections === void 0 ? void 0 : selections.length) ? {
        interactive: !!selections
      } : {}), {
        update: value
      });
    }
  }

  if (!isEmpty(legendEncode)) {
    legendCmpt.set('encode', legendEncode, !!(legend === null || legend === void 0 ? void 0 : legend.encoding));
  }

  return legendCmpt;
}

function parseNonUnitLegend(model) {
  var _model$component = model.component,
      legends = _model$component.legends,
      resolve = _model$component.resolve;

  var _iterator2 = _createForOfIteratorHelper(model.children),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var child = _step2.value;
      parseLegend(child);

      var _iterator4 = _createForOfIteratorHelper(keys(child.component.legends)),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var channel = _step4.value;
          resolve.legend[channel] = parseGuideResolve(model.component.resolve, channel);

          if (resolve.legend[channel] === 'shared') {
            // If the resolve says shared (and has not been overridden)
            // We will try to merge and see if there is a conflict
            legends[channel] = mergeLegendComponent(legends[channel], child.component.legends[channel]);

            if (!legends[channel]) {
              // If merge returns nothing, there is a conflict so we cannot make the legend shared.
              // Thus, mark legend as independent and remove the legend component.
              resolve.legend[channel] = 'independent';
              delete legends[channel];
            }
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  var _iterator3 = _createForOfIteratorHelper(keys(legends)),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var _channel = _step3.value;

      var _iterator5 = _createForOfIteratorHelper(model.children),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var _child = _step5.value;

          if (!_child.component.legends[_channel]) {
            // skip if the child does not have a particular legend
            continue;
          }

          if (resolve.legend[_channel] === 'shared') {
            // After merging shared legend, make sure to remove legend from child
            delete _child.component.legends[_channel];
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  return legends;
}

export function mergeLegendComponent(mergedLegend, childLegend) {
  var _a, _b, _c, _d;

  if (!mergedLegend) {
    return childLegend.clone();
  }

  var mergedOrient = mergedLegend.getWithExplicit('orient');
  var childOrient = childLegend.getWithExplicit('orient');

  if (mergedOrient.explicit && childOrient.explicit && mergedOrient.value !== childOrient.value) {
    // TODO: throw warning if resolve is explicit (We don't have info about explicit/implicit resolve yet.)
    // Cannot merge due to inconsistent orient
    return undefined;
  }

  var typeMerged = false; // Otherwise, let's merge

  var _iterator6 = _createForOfIteratorHelper(LEGEND_COMPONENT_PROPERTIES),
      _step6;

  try {
    var _loop = function _loop() {
      var prop = _step6.value;
      var mergedValueWithExplicit = mergeValuesWithExplicit(mergedLegend.getWithExplicit(prop), childLegend.getWithExplicit(prop), prop, 'legend', // Tie breaker function
      function (v1, v2) {
        switch (prop) {
          case 'symbolType':
            return mergeSymbolType(v1, v2);

          case 'title':
            return mergeTitleComponent(v1, v2);

          case 'type':
            // There are only two types. If we have different types, then prefer symbol over gradient.
            typeMerged = true;
            return makeImplicit('symbol');
        }

        return defaultTieBreaker(v1, v2, prop, 'legend');
      });
      mergedLegend.setWithExplicit(prop, mergedValueWithExplicit);
    };

    for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator6.e(err);
  } finally {
    _iterator6.f();
  }

  if (typeMerged) {
    if ((_b = (_a = mergedLegend.implicit) === null || _a === void 0 ? void 0 : _a.encode) === null || _b === void 0 ? void 0 : _b.gradient) {
      deleteNestedProperty(mergedLegend.implicit, ['encode', 'gradient']);
    }

    if ((_d = (_c = mergedLegend.explicit) === null || _c === void 0 ? void 0 : _c.encode) === null || _d === void 0 ? void 0 : _d.gradient) {
      deleteNestedProperty(mergedLegend.explicit, ['encode', 'gradient']);
    }
  }

  return mergedLegend;
}

function mergeSymbolType(st1, st2) {
  if (st2.value === 'circle') {
    // prefer "circle" over "stroke"
    return st2;
  }

  return st1;
}